<template>
  <div class="sidebar">
    <div class="sidebar-header">
      <div class="logo-area">
        <div class="logo-circle app-logo">
          <span class="logo-text">APP</span>
        </div>
        <div class="company-info">
          <span class="company-name">{{ companyName }}</span>
        </div>
      </div>
    </div>

    <ul class="sidebar-menu">
      <li class="menu-item" :class="{ active: currentTab === 'appOverview' }">
        <button @click="$emit('navigate', 'appOverview')">
          <i class="fas fa-tachometer-alt"></i>
          <span>APP 概览</span>
        </button>
      </li>

      <li class="menu-item" :class="{ active: currentTab === 'appUsers' }">
        <button @click="$emit('navigate', 'appUsers')">
          <i class="fas fa-users"></i>
          <span>用户授权</span>
        </button>
      </li>

      <li class="menu-item" :class="{ active: currentTab === 'appDevices' }">
        <button @click="$emit('navigate', 'appDevices')">
          <i class="fas fa-mobile-alt"></i>
          <span>设备管理</span>
        </button>
      </li>

      <li class="menu-item" :class="{ active: currentTab === 'appLogs' }">
        <button @click="$emit('navigate', 'appLogs')">
          <i class="fas fa-history"></i>
          <span>操作日志</span>
        </button>
      </li>
    </ul>

    <div class="sidebar-toggle" @click="toggleSidebar">
      <i class="fas fa-chevron-left"></i>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  currentTab: { type: String, default: 'appOverview' }
})
defineEmits(['navigate'])

const companyName = ref('顾德智能')

const toggleSidebar = () => {
  const sidebar = document.querySelector('.sidebar')
  if (sidebar) sidebar.classList.toggle('collapsed')
  const wrapper = document.querySelector('#wrapper')
  if (wrapper) wrapper.classList.toggle('collapsed')
}
</script>

<style scoped>
.sidebar {
  width: 220px; min-height: 100vh; position: fixed; top: 0; left: 60px;
  z-index: 1000; background: #1e1b4b; transition: width 0.3s ease; overflow-y: auto; overflow-x: visible;
}
.sidebar.collapsed { width: 50px; }
.sidebar-header { padding: 12px; background: #0f0d2e; display: flex; align-items: center; }
.logo-area { display: flex; align-items: center; gap: 10px; }
.logo-circle { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 10px rgba(0,0,0,0.3); }
.app-logo { background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%); }
.logo-text { color: #fff; font-size: 12px; font-weight: 700; }
.company-info { display: flex; flex-direction: column; }
.company-name { color: #fff; font-size: 14px; font-weight: 600; white-space: nowrap; }
.sidebar.collapsed .company-info { display: none; }

.sidebar-menu { list-style: none; margin: 0; padding: 10px 0; }
.menu-item { position: relative; }
.menu-item > button {
  width: 100%; padding: 12px 20px; background: none; border: none; color: #a5b4fc;
  cursor: pointer; display: flex; align-items: center; gap: 12px; font-size: 13px;
  transition: all 0.2s; text-align: left;
}
.menu-item > button:hover { background: rgba(255,255,255,0.05); color: #e0e7ff; }
.menu-item.active > button { color: #fff; background: rgba(139,92,246,0.15); border-left: 3px solid #8b5cf6; }
.menu-item > button i { width: 18px; text-align: center; font-size: 14px; }

.sidebar-toggle {
  position: absolute; bottom: 20px; left: 0; right: 0; display: flex;
  justify-content: center; cursor: pointer; color: #6366f1; padding: 10px; transition: color 0.2s;
}
.sidebar-toggle:hover { color: #fff; }
.sidebar-toggle i { font-size: 14px; }
</style>
